import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useView } from '../context/ViewContext';
import Navbar from './Navbar';
import Footer from './Footer';
import AdminLayout from './AdminLayout';
import UserLayout from './UserLayout';

export default function Layout({ children }) {
  const { user } = useAuth();
  const { activeView, canAccessView, hasMultipleViews } = useView();
  const location = useLocation();

  if (location.pathname === '/acceptation-documents') {
    return children;
  }
  
  // Routes publiques qui n'utilisent pas de sidebar
  const publicRoutes = ['/', '/login', '/register', '/about', '/contact', '/forgot-password'];
  const isPublicRoute = publicRoutes.includes(location.pathname) || 
                        location.pathname.startsWith('/reset-password');
  
  // Si l'utilisateur est connecté et pas sur une route publique
  if (user && !isPublicRoute) {
    // PRIORITÉ 1 : Forcer le layout basé sur la route explicite
    // Si on est sur une route user (/dashboard, /mes-adhesions, etc.), toujours utiliser UserLayout
    // if (isUserRoute && canAccessView('user')) {
    //   return <UserLayout>{children}</UserLayout>;
    // }
    
    // // Si on est sur une route admin (/adhesions, /admin, etc.), toujours utiliser AdminLayout
    // if (isAdminRoute && canAccessView('admin')) {
    //   return <AdminLayout>{children}</AdminLayout>;
    // }
    
    // PRIORITÉ 2 : même règle que ViewContext.hasMultipleViews (admin OU super_admin) + rôle user
    if (hasMultipleViews()) {
      if (activeView === 'admin' && canAccessView('admin')) {
        return <AdminLayout>{children}</AdminLayout>;
      } else if (activeView === 'user' && canAccessView('user')) {
        return <UserLayout>{children}</UserLayout>;
      }
    }
    
    // PRIORITÉ 3 : Par défaut selon le rôle principal
    if (user.role === 'admin' || user.role === 'super_admin') {
      return <AdminLayout>{children}</AdminLayout>;
    }
    
    if (canAccessView('user')) {
      return <UserLayout>{children}</UserLayout>;
    }
  }
  
  // Sinon, utiliser le layout classique avec navbar (pour les pages publiques)
  return (
    <div className="min-h-screen bg-slate-100 relative overflow-hidden">
      {/* Radial gradient background - 1/3 hidden at top */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 50% -25%, #FFC8B7 15%, #FCEFDF 30%, transparent 40%)',
          height: '100%',
          width: '100%',
        }}
      />
      
      <div className="relative z-10">
        <Navbar />
        <main className="mx-auto py-6 sm:px-6 lg:px-8 mt-10">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
}
